import { Component, OnInit } from '@angular/core';
import { KycSearchRequest, TokenRequest, TokenResponse, KycSearchResponse, MasterAppData, MasterAppList } from './kyc-hyperverge.model';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, NgForm } from '@angular/forms';
import { KycHypervergeService } from './kyc-hyperverge.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kyc-hyperverge',
  templateUrl: './kyc-hyperverge.component.html',
  styleUrls: ['./kyc-hyperverge.component.css']
})
export class KycHypervergeComponent implements OnInit {

  searchRequest: KycSearchRequest;
  errMsg: string;
  successMsg: string;
  isLoading: boolean;
  public currentDate = new Date();
  showValidationMsgs: boolean = false;
  tokenRequest: TokenRequest;
  appNameList: any = [];
  dateOfBirthDoi: any;
  customerTypeList: any = [];


  constructor(public datePipe: DatePipe, private kycHypervergeService: KycHypervergeService, private router: Router) {
    this.customerTypeList = [{ key: 'Individual', value: 'I' }, { key: 'Corporate', value: 'C' }];
    this.searchRequest = new KycSearchRequest();
    this.tokenRequest = new TokenRequest();
  }

  public parseDateFormat(value): void {
    if (value) {
      let formattedDate: string = this.datePipe.transform(value, 'dd/MM/yyyy');
      this.searchRequest.dob_doi = formattedDate;
      console.log(formattedDate);
    }
  }

  setAppIdAndKey(value) {
    this.searchRequest.appId = '';
    this.searchRequest.appKey = '';
    if (value) {
      this.searchRequest.appId = value;
      this.searchRequest.appKey = value;
    }

  }

  ngOnInit(): void {
    this.fetchMasterAppList();
  }

  fetchMasterAppList() {
    this.isLoading = true;
    this.kycHypervergeService.fetchMasterAppList().subscribe((data : MasterAppData) => {
      this.isLoading = false;
      this.appNameList = data.masterAppList;
    });
  }

  submitKycDetails(kycDetailsForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(kycDetailsForm.form);
    } else {
      let isContinue = this.validateData();
      if (!isContinue) {
        this.setData();
        this.isLoading = true;
        this.kycHypervergeService.generateKYCToken(this.tokenRequest).subscribe((data: TokenResponse) => {
          this.isLoading = false;
          if (data.errorMsg) {
            this.errMsg = data.errorMsg;
          } else {
            this.searchRequest.token = data.token;
            this.isLoading = true;
            this.kycHypervergeService.kycSearchDownload(this.searchRequest).subscribe((searchRes: KycSearchResponse) => {
              this.isLoading = false;
              if (searchRes.errMsg) {
                this.errMsg = searchRes.errMsg;
              } else {
                if (searchRes.url) {
                  window.location.replace(searchRes.url);
                }
                else if (searchRes.kycDetails && searchRes.kycDetails.ckycNo) {
                  this.router.navigate(['/kycStatus'], { queryParams: { 'uniqueId': searchRes.uniqueId } })
                }
              }
            });
          }
        });
      } else {
        this.errMsg = isContinue;
      }
    }
  }

  setData() {
    this.tokenRequest.appId = this.searchRequest.appId;
    this.tokenRequest.appKey = this.searchRequest.appKey;
    this.tokenRequest.customerName = this.searchRequest.customerName;
    this.tokenRequest.dob = this.searchRequest.dob_doi;
    this.tokenRequest.redirectedUrl = this.searchRequest.returnURL;
    if (this.searchRequest.policyNo) {
      this.searchRequest.uniqueId = this.searchRequest.policyNo;
    } else if (this.searchRequest.quoteNo) {
      this.searchRequest.uniqueId = this.searchRequest.quoteNo;
    }
  }

  validateData() {
    if (!this.searchRequest.policyNo && !this.searchRequest.quoteNo) {
      return "Please provide Policy No or Quote No";
    }
    return "";
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  routeToSearch() {
    this.router.navigate(['/kyc-search'])
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  onLogOut() {
    sessionStorage.clear();
    window.location.reload();
    this.router.navigate(['/logout']);
  }

}
